import React, { useState } from 'react';
import { Modal, Button, Form, ModalBody, ModalHeader, ModalFooter, FormGroup, Label, Row, Col, Input, Container, FormFeedback, } from 'reactstrap';
import { ListOrderingItem } from '../../../components/lists/ListOrderingItem';
import { Dialog } from 'primereact/dialog';
export const ModalOrderPrintAnalytes = (props) => {

    const {
        analytesGroupPrint, handleModalOrderPrint: toggle, modalOrderPrint, loadingOrderPrint, saveOrderPrintAnalytes
    } = props;

    const [preview, setPreview] = useState(false);

     const previewHeader = (
        <div className="d-flex justify-content-between align-items-center">
            <h7 className="m-0">Ordernar analitos para su impresión</h7>
                <Button className="btn-sm" color='primary' onClick={() => setPreview(!preview)} style={{padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"}}>
                    {
                        preview === true ?
                            <i className='fa fa-pencil-square-o' title='Edición'></i>  : <i className='fa fa-eye' title='Vista previa'></i> 
                    }
                </Button>
                    <br />
        </div>
    );

    return (
        <Dialog 
            header={previewHeader}
            visible={modalOrderPrint}
            onHide={toggle}
            closable={true}
            modal
            blockScroll
            className="adaptive-dialog"
        >
                {
                    preview === false ?
                        <>
                        
                            <label className="text-gray text-sm">Arrastre y suelte los grupos y analitos para su <b>orden de impresión</b></label>
                            <ListOrderingItem itemsOrdered={analytesGroupPrint} {...{ modalOrder: modalOrderPrint }} />
                        </>
                        :
                        <>
                            <ul className="list-circle pl-3">
                                {
                                    analytesGroupPrint.map((obj, key) => {
                                        return <li key={key}>{obj.content}
                                            <ul className="list-circle pl-3">
                                                {
                                                    obj.subItems.map((sub, key2) => {
                                                        return <li key={key2}>
                                                            {sub.content}
                                                        </li>
                                                    })
                                                }
                                            </ul>
                                        </li>
                                    })
                                }
                            </ul>
                        </>
                }
            <ModalFooter>
                <Button
                    onClick={() => saveOrderPrintAnalytes(analytesGroupPrint)}
                    color="primary"
                    type="submit"
                    className={loadingOrderPrint ? "disabled progress-bar-animated progress-bar-striped" : ""}
                >
                    Ordenar analitos
                </Button>
                <Button color="danger" type="button" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Dialog>
    )
}
